import Member from './Member';

export default class MemberWithAttendances {
    static fromData(data) {
        if (!data) {
            return;
        }

        const memberWithAttendances = new MemberWithAttendances();

        memberWithAttendances.member = Member.fromData(data.member);
        memberWithAttendances.canAttendanceBeCreatedOrEdited = data.member.canAttendanceBeCreatedOrEdited;
        memberWithAttendances.attendances = data.attendances;

        Object.seal(memberWithAttendances);
        return memberWithAttendances;
    }
}
